module.exports = __webpack_public_path__ + "static/media/comunidad.a85a5dd7.svg";